<template>
  <div :class="{
    btnWrap: true,
    disabled: isDisabled
  }">
    <div v-if="usableCoupon.length > 0"
      class="usableCouponMessage">
      <span>{{useCoupon && useCoupon.useCoupon ? locale.message_page_applied_coupon : locale.message_page_usable_coupon}}</span>
    </div>
    <div v-if="isDisabled" class="messages notranslate">
      <p v-if="!validCode" class="validateMessage">{{locale.invalid_code}}</p>
      <p v-if="!isAuth" class="validateMessage">{{locale.invalid_key}}</p>
      <p v-if="!pageState.available" class="validateMessage" @click.stop="onTableOpen">{{locale.not_available}}<i>{{locale.available_time}}</i></p>
      <p v-if="disabledSubmit === 'checkOutAble'" class="validateMessage">{{locale.message_disabled_checkoutable_1}}</p>
      <p v-if="requiredCoupon && !usableCoupon.length" class="validateMessage">{{locale.message_required_coupon}}</p>
      <p v-if="pleaseWait" class="validateMessage">{{locale.is_processing}} {{locale.please_wait}}</p>
    </div>
    <button type="submit" class="btn btnFull"
      v-html="item.value[lang]"
      :style="detailStyle"
      :disabled="isDisabled"
      @click.stop="onConfirm"></button>
    <AvailableTable
      v-if="!pageState.available && availableTable"
      :table="pageInfo.available"
      :locale="locale"
      @close="onTableClose" />
    <Summary v-if="summaryData !== null"
      :pageId="pageId"
      :lang="lang"
      :locale="locale"
      :summary="summaryData"
      :isCart="isCart"
      :isExpresscheckin="isExpresscheckin"
      :isCheckout="isCheckout"
      :disabledSubmit="disabledSubmit"
      :usableCoupon="usableCoupon"
      :useCoupon="useCoupon"
      :hiddenPrice="hiddenPrice"
      @updateUsableCoupon="updateUsableCoupon"
      @applyCoupon="applyCoupon"
      @confirm="confirmSummary" />
    <UserInfo v-if="paymentUserInfo"
      :lang="lang"
      :locale="locale"
      @confirm="confirmPaymentUserInfo" />
    <div v-if="toastList">
      <Toast v-for="toast in toastList"
        :locale="locale"
        :key="toast.id"
        :toast="toast"
        @confirm="toastConfirm" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UNIQUE from '@/common/unique'
import AvailableTable from '@/components/Util/AvailableTable.vue'
import Summary from '@/components/Page/Summary.vue'
import moment from 'moment-timezone'
import UserInfo from '@/components/Payment/UserInfo.vue'
import regExp from '@/common/regExp'
import Toast from '@/components/Util/Toast'

export default {
  name: 'Submit',
  components: {
    AvailableTable,
    Summary,
    UserInfo,
    Toast
  },
  props: [
    'pageId',
    'id',
    'item',
    'lang',
    'locale',
    'detailStyle',
    'pageGuestType',
    'isFolioInfo',
    'disabledSubmit',
    'usableCoupon'
  ],
  computed: {
    ...mapGetters({
      getPage: 'page/getPage',
      getAuthInfo: 'authentication/getAuthInfo',
      getSubmitData: 'submit/getSubmitData',
      getPriceInfo: 'page/getPriceInfo',
      getPriceOption: 'page/getPriceOption',
      pageState: 'page/getPageState',
      getSubmitCode: 'submit/getSubmitCode',
      getGuestTypePrice: 'util/getGuestTypePrice',
      getCouponDiscountPrice: 'util/getCouponDiscountPrice',
      getTax: 'payment/getTax',
      setLink: 'util/setLink',
      getIsPageReady: 'page/getIsPageReady'
    }),
    isDisabled () {
      const requiredCoupon = this.requiredCoupon
      /**
       * pageStat.available: 페이지 공개|비공개
       * isAuth: 사전체크인 || valid ota
       * validCode: 유효 전송코드
       * /disabledSubmit: folioInfo - paymentAble: false이면 결제불가, 전송자체도 불가한 케이스
       * pleaseWait: 잠시만 기다려주세요 - 필수입력모듈 계산
       */
      return requiredCoupon
        ? !(this.usableCoupon && this.usableCoupon.length)
        : !this.pageState.available || !this.isAuth || !this.validCode || this.disabledSubmit === 'checkOutAble' || this.pleaseWait
    },
    pleaseWait () {
      const isSubmitReady = this.getIsPageReady
      return !isSubmitReady
    },
    activeUserInfo () {
      return this.$store.state.common.setting.order && !this.$store.state.common.setting.order.disabled
    },
    isPublic () {
      return this.getAuthInfo.public === 'true'
    },
    timezone () {
      return this.$store.state.siteInfo.timezoneId || ''
    },
    isExpresscheckin () {
      const expressCheckin = this.getPage.submit && this.getPage.submit.submitTo === 'system_express_checkin'
      return expressCheckin
    },
    isCheckout () {
      const checkout = this.getPage.submit && this.getPage.submit.submitTo === 'system_checkout'
      return checkout
    },
    currencyCode () {
      return this.$store.getters['common/getSetting'].currency.toUpperCase()
    },
    disabledTax () { // 금액 정보에 tax가 포함된 경우 따로 계산 하지않음
      return this.$store.state.page.disabledTax === true
    },
    tax () {
      return !this.disabledTax && this.$store.state.payment.tax
    },
    disabledRoomCharge () { // 후불결제 안됨
      return this.isCheckout
    },
    guestTypePrice () {
      const info = this.pageGuestType
      const priceInfo = this.priceInfo
      const quantity = priceInfo.quantity || 1
      const price = priceInfo.price || 0
      const sum = priceInfo.sum || 0
      const total = (price + sum) * quantity
      const getGuestTypePrice = info ? this.getGuestTypePrice(info, total) : null
      return info && info.active && info.discount
        ? {
          id: info.id,
          name: info.name,
          ...getGuestTypePrice,
          quantity: quantity,
          total: getGuestTypePrice.price
        }
        : null
    },
    priceInfo () {
      const sum = this.getPriceOption.reduce((a, b) => a + (b.quantity ? b.price * b.quantity : b.price), 0)
      const basePrice = this.getPriceInfo.price ? Number(this.getPriceInfo.price) : 0
      const baseQuantity = this.getPriceInfo.quantity ? Number(this.getPriceInfo.quantity) : 1
      const discount = this.getPriceInfo.discount || 0
      const total = (basePrice + sum) * baseQuantity - discount <= 0 ? 0 : (basePrice + sum) * baseQuantity - discount
      const taxPer = this.tax
      const tax = this.getTax(total)
      const taxTotal = total + tax
      const noPrice = Object.keys(this.getPriceInfo).length === 0 && this.getPriceOption.length === 0
      return {
        currency: this.currencyCode,
        price: this.getPriceInfo.price ? basePrice : null,
        quantity: this.getPriceInfo.quantity ? baseQuantity : null,
        sum: sum,
        total: total,
        ...discount && {
          discount: discount
        },
        ...taxPer && {
          subtotal: total,
          tax: tax,
          taxLabel: `${taxPer}%`,
          total: taxTotal
        },
        noPrice: noPrice
      }
    },
    isCart () {
      return this.getPage.submit.cart && !(
        this.getPage.submit.submitTo === 'system_express_checkin' ||
        this.getPage.submit.submitTo === 'system_checkout'
      )
    },
    userInfoInput () {
      return this.getPage.submit.userInfoInput
    },
    pageInfo () {
      const info = this.getPage
      return {
        available: info.available.set,
        subject: info.submit.subject,
        thumbnail: info.thumbnail
      }
    },
    validCode () {
      const codes = this.getSubmitCode.map(x => x.id)
      const submitTo = this.$store.state.page.page.submit.submitTo
      return codes.includes(submitTo)
    },
    /**
     * 실제 submit 전 valite date
     * 옵션의 서브옵션 등이 생겨
     * 검사조건이 변동됨
     */
    validateSubmit () {
      const mods = this.getSubmitData
      let result = []
      function getValue (val) {
        const value = Array.isArray(val) ? val.map(x => x.split('_').splice(1).join('')) : [val.split('_').splice(1).join('')]
        return value
      }
      function setSubOption (arr, obj) {
        const valueArr = getValue(obj.value)
        if (!result.find(x => x.id === obj.id)) {
          result.push(obj)
        }
        if (obj.subOption) {
          for (let j = 0; j < obj.subOption.length; j++) {
            const opt = obj.subOption[j]
            if (valueArr.includes(opt.value)) {
              const subOptionMod = arr.find(x => x.id === opt.subOption)
              if (subOptionMod) {
                setSubOption(arr, subOptionMod, getValue(subOptionMod.value))
              }
            }
          }
        }
      }
      function parentHasValue (arr, id, parentId) {
        const mod = arr.find(x => x.id === parentId)
        return mod
          ? getValue(mod.value).filter(x => x !== '').length > 0 && getValue(mod.value).includes(id)
          : false
      }
      function getOptionDepth (depth, arr, id) {
        const item = arr.find(x => x.id === id)
        if (item && item.isSubOption) {
          depth += 1
          return getOptionDepth(depth, arr, item.parentOption)
        } else {
          return depth
        }
      }
      for (let i = 0; i < mods.length; i++) {
        const mod = mods[i]
        // 서브옵션이 없으면 pass
        if (!mod.isSubOption && !mod.hasSubOption) {
          result.push(mod)
        /**
         * 서브옵션이 있으면
         * 선택한 값에 따른 옵션 추가
         * 1, 1-1, 1-2, 2, 2-1, 2-1-1, 2-1-2, 2-2...
         * 와 같은 순으로 순차적 배열
         */
        } else if (mod.hasSubOption && mod.subOption) {
          // 서브옵션인데 메인옵션이 선택되지 않으면 pass
          if (!mod.isSubOption || (mod.isSubOption && parentHasValue(mods, mod.id, mod.parentOption))) {
            setSubOption(mods, mod)
          }
        }
      }
      return result.map(x => {
        return {
          ...x,
          ...x.valueOption && {
            // 옵션 선택시(select, radio, checkbox) 입력필드 생성
            valueOption: x.name === 'checkbox'
              ? x.valueOption.map((k, i) => {
                const value = x.value.find((v, idx) => idx === i)
                return {
                  ...k,
                  index: Number(value.split('_').splice(0)[0])
                }
              })
              : {
                ...x.valueOption,
                index: Number(x.value.split('_').splice(0)[0])
              }
          },
          optionDepth: getOptionDepth(0, result, x.id)
        }
      })
    },
    pIdItems () {
      const options = _.cloneDeep(this.validateSubmit)
      return options.filter(x => x.valueOption)
        .filter(x => Array.isArray(x.valueOption)
          ? x.valueOption.filter(v => v.pIdActive && v.pId && regExp.replaceAllEmpty(v.pId) !== '').length > 0
          : x.valueOption.pIdActive && x.valueOption.pId && regExp.replaceAllEmpty(x.valueOption.pId) !== '')
        .map(x => x.valueOption).flat(Infinity)
        .map(x => {
          if (x.pIdType === '#none') {
            delete x.pIdType
          }
          const price = x.price ? Number(x.price) : 0
          const quantity = x.quantity ? parseInt(x.quantity) : 1
          return {
            ...x,
            price: price,
            quantity: quantity,
            ...this.tax && {
              subtotal: price * quantity,
              tax: this.getTax(price * quantity),
              total: price * quantity + this.getTax(price * quantity)
            }
          }
        })
    },
    /**
     * pms 등으로 전달하기 위한 system id (예약어와 같은 데이터)
     */
    systemInfo () {
      const priceInfo = this.priceInfo
      const returnValue = function (data) {
        let value
        switch (data.name) {
          case 'radio':
            value = data.value
              ? data.value.split('_').splice(1).join('')
              : null
            break
          case 'select':
            value = data.value
              ? data.value.split('_').splice(1).join('')
              : null
            break
          case 'checkbox':
            value = data.value.length
              ? data.value.map((x, i) => {
                const val = x.split('_').splice(1).join('')
                return val
              })
              : null
            break
          case 'rate':
            value = data.value
            break
          case 'quantity':
            value = priceInfo
            break
          default:
            value = data.value !== '' ? data.value : null
        }
        return value
      }
      const mods = this.getSubmitData.filter(x => x.dataVariable)
      const systemIds = mods.reduce((obj, item) => ({ ...obj, ...{ [item.dataVariable]: returnValue(item) } }), {})
      const cert = this.getSubmitData.find(x => x.name === 'cert')
      const rid = this.$store.state.authentication.rid // 예약번호(rId)
      const certInfo = cert ? { // 본인인증을 통한 정보는 고정
        guestName: cert.value.name,
        dateOfBirth: cert.value.birthDate,
        guestPhone: cert.value.phone,
        ...cert.value
      } : {}
      return {
        ...systemIds,
        ...certInfo,
        ...rid && { rid: rid }
      }
    },
    getRid () {
      return this.$store.state.authentication.rid
    },
    returnUrl () {
      const isReturnUrl = this.getPage.submit && this.getPage.submit.submitReturnUrl
      const url = isReturnUrl && this.getPage.submit.submitReturnUrlLink
      return url && {
        link: url,
        url: this.setLink(url).href
      }

    },
    noSummary () { // 확인창 없이 바로 전송
      const isFolioInfo = this.isFolioInfo
      const folioAmount = this.submitData && this.submitData.price && this.submitData.price.info && this.submitData.price.info.total
      return isFolioInfo && folioAmount <= 0
    },
    isUserinfo () {
      const inputs = this.$store.getters['common/getUserinfo']
      const isFirstName = inputs.firstName !== false
      const isLastName = inputs.lastName !== false
      const isTel = inputs.tel !== false
      const isEmail = inputs.email !== false
      const isCustom = inputs.custom && inputs.custom.length > 0
      return isFirstName || isLastName || isTel || isEmail || isCustom
    },
    hiddenPrice () {
      return this.getPage.submit && this.getPage.submit.isSubmit && this.getPage.submit.hiddenPrice
    },
    requiredCoupon () {
      return this.getPage.submit && this.getPage.submit.isSubmit && this.getPage.submit.requiredCoupon
    },
    fromProduct () {
      // 상품에 연결된 페이지인지?
      return {
        productId: this.$route.params.productId,
        productItemId: this.$route.meta.productItemId
      }
    }
  },
  watch: {
    guestTypePrice (data) {
      if (data) {
        const guestTypePrice = parseInt(data.discountPrice) * -1
        const couponPrice = this.useCoupon && this.useCoupon.couponPrice ? this.useCoupon.couponPrice.priceDiscount : 0
        this.$store.state.page.priceInfo.discount = guestTypePrice + couponPrice
        this.$store.state.page.priceInfo.total = data.normalPrice - (guestTypePrice + couponPrice)
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    this.payment = null
  },
  created () {
    this.$store.dispatch('submit/getSubmitCode')
    this.getCartList()
  },
  async mounted () {
    await this.getKey()
    if (this.pageGuestType && this.guestTypePrice) {
      const defaultDiscount = parseInt(this.guestTypePrice.discountPrice) * -1
      this.$store.commit('page/priceInfo', { discount: defaultDiscount })
    }
  },
  data () {
    return {
      availableTable: false,
      submitData: null,
      summaryData: null,
      cartData: null,
      submitWay: false,
      submitDir: null,
      cartList: [],
      payment: null,
      paymentUserInfo: null,
      key: this.$store.state.authentication.k,
      isAuth: false,
      useCoupon: null,
      toastList: []
    }
  },
  methods: {
    async getKey () {
      if (this.isPublic) {
        const res = await this.$store.dispatch('authentication/getOtaKey')
        this.key = res
      }
      this.checkAuth()
    },
    updateUsableCoupon (couponList) {
      this.$emit('updateUsableCoupon', couponList)
    },
    applyCoupon (coupon) {
      const priceInfo = this.priceInfo
      const quantity = priceInfo.quantity || 1
      const price = priceInfo.price || 0
      const sum = priceInfo.sum || 0
      const total = (price + sum) * quantity
      const getCouponDiscountPrice = this.getCouponDiscountPrice(coupon, total)
      const couponData = coupon && coupon.length ? {
        useCoupon: coupon,
        ...getCouponDiscountPrice && {
          couponPrice: getCouponDiscountPrice
        }
      } : null
      const guestTypeDiscount = this.guestTypePrice && this.guestTypePrice.discountPrice ? parseInt(this.guestTypePrice.discountPrice) : 0
      const defaultDiscount = (guestTypeDiscount * -1) // 게스트타입에는 금액 증감이 둘다 있기 때문에 기본 할인은 -로 표기한다
      if (couponData) {
        if (!getCouponDiscountPrice) {
          const disCountPriceInfo = {
            ...priceInfo,
            discount: defaultDiscount,
            total: getCouponDiscountPrice ? getCouponDiscountPrice.normalPrice : 0
          }
          this.$store.commit('page/priceInfo', disCountPriceInfo)
        } else {
          const disCountPriceInfo = {
            ...priceInfo,
            discount: defaultDiscount + getCouponDiscountPrice.priceDiscount,
            total: getCouponDiscountPrice.price
          }
          this.$store.commit('page/priceInfo', disCountPriceInfo)
        }
        this.useCoupon = couponData
      } else {
        const disCountPriceInfo = {
          ...priceInfo,
          discount: defaultDiscount,
          total: getCouponDiscountPrice ? getCouponDiscountPrice.normalPrice : 0
        }
        delete this.summaryData.useCoupon
        delete this.submitData.useCoupon
        delete this.cartData.useCoupon
        this.$store.commit('page/priceInfo', disCountPriceInfo)
        this.useCoupon = null
      }
      this.summaryData = {
        ...this.summaryData,
        ...couponData && {
          useCoupon: couponData
        },
        ...this.summaryData.price && {
          price: {
            ...this.summaryData.price,
            info: this.priceInfo
          }
        }
      }
      this.submitData = {
        ...this.submitData,
        ...couponData && {
          useCoupon: couponData
        },
        ...this.submitData.price && {
          price: {
            ...this.submitData.price,
            info: this.priceInfo
          }
        }
      }
      this.cartData = {
        ...this.cartData,
        ...couponData && {
          useCoupon: couponData
        },
        ...this.cartData.price && {
          price: {
            ...this.cartData.price,
            info: this.priceInfo
          }
        }
      }
    },
    checkAuth () {
      const getAuthInfo = this.$store.getters['authentication/getAuthInfo']
      const key = this.key
      const space = getAuthInfo.space
      const hasKey = key && key !== 'undefined'
      const hasSpace = space && space !== 'undefined'
      const isKeyValid = !(getAuthInfo.otavalid && getAuthInfo.otavalid === 'false')
      const expressCheckin = this.getPage.submit && this.getPage.submit.submitTo === 'system_express_checkin'
      this.isAuth = expressCheckin || (hasKey && hasSpace && isKeyValid)
    },
    getCartList () {
      this.cartList = []
      if (localStorage.length > 0) {
        for (let i = 0; i < localStorage.length; i++) {
          // cart_pageId로 시작하는 items
          if (localStorage.key(i).includes('cart_')) {
            const cartItem = JSON.parse(localStorage.getItem(localStorage.key(i)))
            this.cartList.push({ ...cartItem, cartId: localStorage.key(i) })
            // this.cartData = this.cartList.find(x => x.pageId === this.getPage.id) || {}
          }
        }
      }
    },
    cloneDeep (data) {
      return _.cloneDeep(data)
    },
    closePayment () {
      this.payment = null
    },
    closePaymentUserInfo () {
      this.paymentUserInfo = null
      this.toggleSummaryPadding('remove')
      this.$emit('setPopover', false)
    },
    onTableOpen () {
      this.availableTable = true
      this.$emit('setPopover', this.id, 9999999)
    },
    onTableClose () {
      this.availableTable = false
    },
    validateOnSubmit () {
      const submitData = this.validateSubmit
      const required = submitData.filter(x => x.type !== 'quantity' && x.type !== 'datetime' && x.passed !== null)
      const passed = required.filter(x => !x.passed)
      const checkCondition = submitData.filter(x => x.condition === false)
      if (passed.length > 0) {
        alert(this.locale.validate_required)
        return false
      } else if (checkCondition.length > 0) {
        alert(this.locale.alert_option_condition)
        return false
      } else {
        return true
      }
    },
    toggleSummaryPadding (toggle) {
      const pageWrap = document.getElementById('productDetailInfo')
      if (pageWrap) {
        pageWrap.classList[toggle]('hasSummary')
      }
    },
    confirmSummary (confirm) {
      const requiredCoupon = this.requiredCoupon
      const hasCoupon = this.useCoupon
      if (confirm && requiredCoupon && !hasCoupon) {
        alert(this.locale.alert_required_coupon)
        return null
      }
      this.summaryData = null
      if (!this.disabledSubmit) {
        if (confirm === 'request') {
          this.summaryData = null
          if (this.activeUserInfo && this.userInfoInput !== false && !this.isExpresscheckin && !this.isCheckout && this.isUserinfo) {
            this.paymentUserInfo = true
            this.$emit('setPopover', this.id, 9999999)
          } else {
            this.onSubmit()
          }
        } else if (confirm === 'cart') {
          this.setCart()
        } else {
          this.summaryData = null
          this.$emit('summaryOn', false)
          this.toggleSummaryPadding('remove')
          this.$emit('setPopover', false)
        }
      } else {
        this.summaryData = null
        this.$emit('summaryOn', false)
        this.toggleSummaryPadding('remove')
      }
      // this.$emit('setPopover', this.id)
    },
    confirmPaymentUserInfo (confirm) {
      if (confirm) {
        this.onSubmit()
      } else {
        this.paymentUserInfo = null
        this.toggleSummaryPadding('remove')
        this.$emit('setPopover', false)
      }
    },
    addToast (trigger, type, message) {
      const id = UNIQUE.mid()
      const toast = {
        id: id,
        type: type,
        trigger: trigger,
        message: message
      }
      this.toastList.push(toast)
    },
    delToast (id) {
      this.toastList = this.toastList.filter(x => x.id !== id)
    },
    toastConfirm (data) {
      const trigger = this.toastList.find(x => x.id === data.id) ? this.toastList.find(x => x.id === data.id).trigger : null
      if (!data.isConfirm) {
        if (trigger === 'goCartPage') {
          this.stayPage()
        } else {
          this.stayPage()
        }
        this.delToast(data.id)
      } else {
        if (trigger) {
          if (trigger === 'addCart') {
            this.addCartItem(data.id)
          } else if (trigger === 'addCartExist') {
            this.addCartItemExist(data.id)
          } else if (trigger === 'goCartPage') {
            this.goCartPage(data.id)
          }
        } else {
          alert(this.locale.alert_system_error)
        }
      }
    },
    addCartItem (id) {
      /**
         * submitData.info.available (this.pageInfo.available)는
         * 이용가능시간 전체 정보가 아닌
         * 현재시각 기준으로 데이터가 가공 되어 있기 때문에
         * 장바구니에는 전체 정보가 필요함
         */
      const ota = this.getAuthInfo.k
      const cartIdx = this.cartList.length
      const pageInfo = { ...this.pageInfo, available: this.getPage.available }
      const cartData = Object.assign(this.cartData, { order: cartIdx }, { info: pageInfo }, { cartOta: ota })
      const cartId = `cart_${UNIQUE.fileid()}_${this.cartData.pageId}`
      const cartContent = JSON.stringify(cartData)
      const cartItem = {
        cartId: cartId,
        ...JSON.parse(localStorage.getItem(cartId))
      }
      localStorage.setItem(cartId, cartContent)
      this.$store.commit('cart/addList', cartItem)
      this.getCartList()
      this.delToast(id)
      this.addToast('goCartPage', 'confirm', `${this.locale.complete_cart_add}\n${this.locale.confirm_cart_page}`)
    },
    goCartPage (id) {
      const lang = this.lang
      this.delToast(id)
      this.$router.push({ name: 'cart', params: { lang: lang } })
    },
    stayPage () {
      this.toggleSummaryPadding('remove')
    },
    setCart () {
      this.addToast('addCart', 'confirm', this.locale.confirm_cart_add)
    },
    onConfirm (e) {
      const isPassed = this.validateOnSubmit()
      const priceInfo = this.priceInfo
      const guestTypePrice = this.guestTypePrice
      const useCoupon = this.useCoupon
      const locale = this.locale
      const timezone = this.timezone
      const hiddenPrice = this.hiddenPrice
      function pIdItemsPrice (arr) {
        return arr.filter(x => x.price).map(x => {
          const quantity = x.quantity || 1
          const price = x.price || 0
          return price * quantity
        }).reduce((a, b) => a + b, 0)
      }
      if (isPassed) {
        const pageData = this.$store.state.page.page
        /**
         * submit data value
         */
        const returnValue = function (data) {
          let value
          switch (data.name) {
            case 'radio':
              value = data.value
                ? data.value.split('_').splice(1).join('')
                : null
              break
            case 'select':
              value = data.value
                ? data.value.split('_').splice(1).join('')
                : null
              break
            case 'checkbox':
              value = data.value.length
                ? data.value.map((x, i) => {
                  const val = x.split('_').splice(1).join('')
                  return val
                })
                : null
              break
            case 'rate':
              value = data.value
              break
            case 'quantity':
              value = priceInfo
              break
            default:
              value = data.value !== '' ? data.value : null
          }
          return value
        }
        /**
         * submit data label
         */
        const returnLabel = function (data) {
          let label
          switch (data.name) {
            case 'datetime':
              label = 'datetime'
              break
            case 'quantity':
              label = 'quantity'
              break
            default:
              label = data.label
          }
          return label
        }
        const submitContent = this.validateSubmit.filter(x => x.name === 'uploadImage' ? x.value && x.value.length > 0 : x).map(x => {
          const value = returnValue(x)
          return {
            id: x.id,
            type: x.name,
            displayLabel: x.displayLabel,
            label: returnLabel(x), // center용 항목명
            isRequired: x.isRequired,
            value: value, // center용 선택값
            ...x.valueIndex && {
              valueIndex: x.valueIndex
            },
            ...x.valueOption && {
              hasSubOption: x.hasSubOption,
              valueOption: x.name === 'checkbox'
                ? x.valueOption.map((v, i) => {
                  const optionVal = value[i]
                  return {
                    ...v,
                    value: optionVal
                  }
                })
                : x.name === 'radio' || x.name === 'select'
                  ? { ...x.valueOption, value: value }
                  : x.valueOption
            },
            ...x.isSubOption && {
              isSubOption: x.isSubOption,
              parentOption: x.parentOption
            },
            ...x.optionDepth && {
              optionDepth: x.optionDepth
            },
            ...x.disabledQty && {
              disabledQty: x.disabledQty
            },
            ...x.translate && {
              translate: x.translate
            }
          }
        })
        const priceOption = this.getPriceOption.length ? this.getPriceOption : null
        /**
         * 옵션에도 pId가 존재할 수 있으며
         * 포스로 전달 등을 위해 옵션 pId만 따로 맵핑하여 저장
         */
        const pIdItems = this.pIdItems
        const pIdItemsPrices = pIdItemsPrice(pIdItems)
        const pIdInfo = pIdItems.length > 0
          ? {
            price: {
              net: priceInfo.total - pIdItemsPrices, // 본 상품 가격
              sum: pIdItemsPrices, // pId items 합계
              total: priceInfo.total, // 총합계
              ...this.tax && {
                subtotal: priceInfo.subtotal,
                tax: priceInfo.tax
              }
            },
            items: pIdItems.map(x => {
              delete x.pIdTypeId
              return x
            })
          }
          : null
        const submitData = {
          title: pageData.title,
          pId: pageData.pId || null,
          pageId: pageData.id,
          submitAt: moment().toISOString(),
          submitId: pageData.submit.submitTo,
          catCode: pageData.submit.submitTo,
          categoryLabel: pageData.submit.submitLabel,
          content: submitContent,
          price: {
            info: {
              ...priceInfo,
              total: guestTypePrice
                ? guestTypePrice.total
                : priceInfo.total
            },
            option: priceOption
          },
          ...pageData.pickup && {
            pickup: pageData.pickup,
            ...pageData.pickup === 'auto' && {
              pickupTime: pageData.pickupTime
            }
          },
          ...guestTypePrice && {
            guestTypePrice: guestTypePrice
          },
          ...pageData.submit.submitCategory && {
            submitCategory: pageData.submit.submitCategory
          },
          ...pIdInfo && {
            pIdInfo: pIdInfo
          },
          ...pageData.pIdType && {
            pIdType: pageData.pIdType
          },
          ...useCoupon && {
            useCoupon: useCoupon
          },
          hiddenPrice: hiddenPrice,
          ...this.fromProduct && {
            productId: this.fromProduct.productId,
            productItemId: this.fromProduct.productItemId
          }
        }
        /**
         * summary data label (display)
         */
        const returnSummaryLabel = function (data) {
          let label
          switch (data.name) {
            case 'datetime':
              label = locale.datetime
              break
            case 'quantity':
              label = locale.quantity
              break
            default:
              label = data.displayLabel
          }
          return label
        }
        /**
         * summary data value (display)
         */
        const returnSummaryValue = function (data) {
          const pageValue = function (mId) {
            const module = pageData.module
            return _.cloneDeep(module.find(x => x.id === mId))
          }
          let value
          let valueIndex
          let dValue
          switch (data.name) {
            case 'select':
              dValue = data.value.split('_').splice(1).join('')
              value = data.value ? pageValue(data.id).setting.action.item.find(x => x.value === dValue) : null
              break
            case 'radio':
              dValue = data.value.split('_').splice(1).join('')
              valueIndex = Number(data.value.split('_').splice(0)[0])
              value = data.value ? pageValue(data.id).setting.action.item.find((x, index) => {
                return x.value === dValue && valueIndex === index
              }) : null
              break
            case 'checkbox':
              dValue = data.value.map(x => x.split('_').splice(1).join(''))
              valueIndex = data.valueIndex
              value = data.value ? pageValue(data.id).setting.action.item.map((x, index) => {
                return {
                  ...x,
                  index: index
                }
              }).filter((x, index) => {
                return dValue.includes(x.value) && valueIndex.includes(index)
              }) : null
              break
            case 'rate':
              value = data.value
              break
            case 'quantity':
              value = priceInfo
              break
            case 'datetime':
              value = {
                ...data.value,
                settime: data.value.type === 'settime' && data.value.settime === ''
                  ? moment().set({ hour: 0, minute: 0, second: 0 }).tz(timezone).toISOString()
                  : data.value.settime
              }
              break
            default:
              value = data.value !== '' ? data.value : null
          }
          return value
        }
        const summaryContent = this.validateSubmit.filter(x => x.name === 'uploadImage' ? x.value && x.value.length > 0 : x).map(x => {
          const value = returnSummaryValue(x)
          return {
            type: x.name,
            label: returnSummaryLabel(x),
            value: value, // center용 선택값
            ...x.valueIndex && {
              valueIndex: x.valueIndex
            },
            ...x.valueOption && {
              hasSubOption: x.hasSubOption,
              valueOption: x.name === 'checkbox'
                ? x.valueOption.map((v, i) => {
                  const optionVal = value[i]
                  return {
                    ...v,
                    value: optionVal
                  }
                })
                : x.name === 'radio' || x.name === 'select'
                  ? { ...x.valueOption, value: value }
                  : x.valueOption
            },
            ...x.isSubOption && {
              isSubOption: x.isSubOption,
              parentOption: x.parentOption
            },
            ...x.optionDepth && {
              optionDepth: x.optionDepth
            },
            ...x.translate && {
              translate: x.translate
            }
          }
        })
        const summaryData = {
          info: this.pageInfo,
          submitAt: submitData.submitAt,
          submitId: submitData.submitId,
          content: summaryContent,
          price: {
            info: priceInfo,
            option: priceOption
          },
          ...guestTypePrice && {
            guestTypePrice: guestTypePrice
          },
          ...useCoupon && {
            useCoupon: useCoupon
          }
        }
        const cartData = {
          // add to cart
          title: pageData.title,
          pId: pageData.pId || null,
          pageId: pageData.id,
          submitAt: moment().toISOString(),
          submitId: pageData.submit.submitTo,
          catCode: pageData.submit.submitTo,
          categoryLabel: pageData.submit.submitLabel,
          content: summaryContent,
          submitContent: submitContent,
          price: {
            info: {
              ...priceInfo,
              total: guestTypePrice
                ? guestTypePrice.total
                : priceInfo.total
            },
            option: priceOption
          },
          ...pageData.pickup && {
            pickup: pageData.pickup,
            ...pageData.pickup === 'auto' && {
              pickupTime: pageData.pickupTime
            }
          },
          ...guestTypePrice && {
            guestTypePrice: guestTypePrice
          },
          ...pageData.submit.submitCategory && {
            submitCategory: pageData.submit.submitCategory
          },
          ...pIdInfo && {
            pIdInfo: pIdInfo
          },
          ...pageData.pIdType && {
            pIdType: pageData.pIdType
          },
          ...useCoupon && {
            useCoupon: useCoupon
          },
          hiddenPrice: hiddenPrice,
          ...this.fromProduct && {
            productId: this.fromProduct.productId,
            productItemId: this.fromProduct.productItemId
          }
        }
        this.submitData = submitData
        // 주문요약 팝업 없이 바로 전송
        if (this.noSummary) {
          this.onSubmit()
        } else {
          this.summaryData = summaryData
          this.cartData = cartData
          // systemid
          this.$store.commit('submit/setSubmitSystemInfo', this.systemInfo)
          this.$emit('summaryOn', true, this.noSummary)
          this.$emit('setPopover', this.id, 9999999)
          /**
           * 상품에서 연결한 경우
           * iOS에서만 summary의 top 기준이 parent로 잡히는 현상이 나타남
           * 아마 중첩된 fixed 처리가 이렇게 되는듯 함
           * summary를 띄울 때 parent fixed el의 padding을 없애기 위한 toggle class
           */
          this.toggleSummaryPadding('add')
        }
      }
    },
    async onSubmit () {
      this.$store.commit('loading', true)
      const ln = this.$route.params.ln
      const isFrame = this.getAuthInfo.frame === 'false' ? '&frame=false' : ''
      const hasReturnUrl = this.returnUrl
      const returnURL = hasReturnUrl
        ? `${window.location.origin}${window.location.pathname}${window.location.search}${isFrame}${hasReturnUrl.url}`
        : `${window.location.origin}${window.location.pathname}${window.location.search}${isFrame}#/${ln}/complete`
      const cancelUrl = `${window.location.origin}${window.location.pathname}${window.location.search}${isFrame}#/${ln}/page/${this.pageId}`
      const submitData = {
        isArray: true,
        payload: [{ ...this.submitData, info: this.pageInfo }],
        price: {
          info: this.priceInfo,
          total: this.priceInfo.total
        },
        ...this.disabledTax && {
          disabledTax: this.disabledTax
        },
        ...this.disabledRoomCharge && {
          disabledRoomCharge: this.disabledRoomCharge
        },
        returnURL: returnURL,
        cancelUrl: cancelUrl
      }
      const isExpresscheckin = this.isExpresscheckin
      const iid = this.useCoupon && this.useCoupon.useCoupon && this.useCoupon.useCoupon.length > 0 ? this.useCoupon.useCoupon.map(x => x.iidOrigin || x.iid) : null
      const checkCoupon = await this.$store.dispatch('coupon/getCoupon')
      this.$store.dispatch('submit/getSubmitCode').then((code) => {
        const systemCode = code[0] || []
        const userCode = code[1] || []
        const submitCode = systemCode.concat(userCode).map(x => x.id)
        this.paymentUserInfo = null
        if (submitCode.includes(submitData.payload[0].submitId)) {
          this.$store.dispatch('submit/setSubmit', submitData).then((res) => {
            if (res && res.status && res.status === 200) {
              if (iid && checkCoupon) {
                // 쿠폰 유효성 체크 (request는 여기서 끝남)
                const validCoupons = this.$store.getters['util/validateCoupon'](checkCoupon, iid)
                if (validCoupons) {
                  this.$store.dispatch('coupon/setWaitCoupon', { iids: iid, returnURL: returnURL })
                } else {
                  this.$store.commit('loading', false)
                }
              }
              // siteInfo.commerce인 경우 결제과정 거친 후 center로 요청
              // 결제중에서도 후불결제(룸차지)를 허용하는 경우 결제방식 선택 페이지로 이동
              const payment = res.payment
              if (payment) {
                const paymentId = res.paymentId
                // const routerName = res.roomCharge ? 'paymentStep' : 'payment'
                const routerName = 'paymentStep'
                this.$router.push({ name: routerName, params: { payment: payment, paymentId: paymentId } })
              } else {
                // center로 바로 요청
                if (hasReturnUrl) {
                  window.location.href = returnURL

                } else {
                  this.$router.push({
                    name: 'complete',
                    params: {
                      ...isExpresscheckin && {
                        from: 'expressCheckin'
                      }
                    }
                  })
                }
              }
            } else {
              if (res.message && res.message.length) {
                if (res.message.includes('Unauthorized')) {
                  // 유효하지 않은 인증키입니다.
                  alert(this.locale.invalid_key)
                  window.location.reload()
                } else if (res.message.includes('amount')) {
                  // 결제할 수 없는 금액입니다.
                  alert(this.locale.alert_amount_cannot_paid)
                } else if (res.message.includes('currency')) {
                  // 지원하지 않는 통화입니다.
                  alert(this.locale.alert_currency_not_support)
                } else {
                  // 시스템에러가 발생했습니다.
                  alert(this.locale.alert_system_error)
                }
              } else {
                // 시스템에러가 발생했습니다.
                alert(this.locale.alert_system_error)
              }
            }
            this.$store.commit('loading', false)
          })
        } else {
          alert(this.locale.invalid_code)
          this.$store.commit('loading', false)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.btnWrap {
  position: relative;
  text-align: center;
  .btn {
    color: inherit;
    border-color: inherit;
    background-color: inherit;
    &[disabled] {
      border-color: $color-grey !important;
      background-color: $color-lgrey !important;
    }
  }
  .messages {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .validateMessage {
    margin-bottom: 2px;
    padding: 5px 10px;
    text-align: center;
    white-space: nowrap;
    color: $color-white;
    border-radius: 20px;
    background-color: rgba($color-red, 0.7);
    i {
      display: inline-block;
      position: relative;
      margin-left: 5px;
      padding: 0 4px;
      font-style: normal;
      color: $color-red;
      border-radius: 4px;
      background-color: $color-white;
    }
  }
}
</style>
